export default function AdminDashboard() {
  return (
    <>
      <div className="text-[#fff] font-bold text-2xl h-screen w-screen bg-[#161E2D]">
        AdminDashboard
      </div>
    </>
  );
}
